import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from 'antd';
import useDatasource from '../../hooks/useDatasource';

import Column from '../../helpers/columns';
import { findSystemParametersByCode } from '../../services/taxonomies/system-parameters';
import ExportEntitiesButton from '../../components/buttons/ExportEntitiesButton';
import {
  downloadOnlyPosesData,
  getPosesData,
} from '../../services/pos/taxonomies-pos';

const PosesStatuses = () => {
  const { t } = useTranslation();

  const fetcher = useCallback(
    (data) =>
      getPosesData({
        ...data,
      }),
    [],
  );

  const downloadFetcher = useCallback(
    (data, spec) => downloadOnlyPosesData(data, spec),
    [],
  );

  const getData = useCallback(
    (params) =>
      fetcher(params).then(async (data) => {
        return data;
      }),
    [fetcher],
  );

  const {
    loading,
    pagination,
    content,
    handleChange,
    reload,
    criterias,
    sort,
  } = useDatasource(getData);

  const [refreshTimeSysParams, setRefreshTimeSysParams] = useState(null);

  const refTime = useRef(Date.now());
  const [alerTrigger, setAlerTrigger] = useState(0);

  useEffect(() => {
    findSystemParametersByCode('EVENT_CHECKER').then((res) =>
      setRefreshTimeSysParams(res),
    );
  }, []);

  const refreshRate = useMemo(() => {
    if (refreshTimeSysParams !== null && refreshTimeSysParams !== undefined) {
      const refreshTime = refreshTimeSysParams.value;
      return refreshTime !== null ? refreshTime * 1000 : null;
    }
    return null;
  }, [refreshTimeSysParams]);

  useEffect(() => {
    const intervalId = setInterval(
      () => setAlerTrigger((val) => val + 1),
      refreshRate + 1,
    );
    return () => {
      clearInterval(intervalId);
    };
  }, [refreshRate]);

  useEffect(() => {
    if (content != null && !loading) {
      if (Date.now() - refTime.current > refreshRate) {
        refTime.current = Date.now();
        reload();
      }
    }
  }, [alerTrigger, refreshRate, reload, loading, content]);

  const columns = useMemo(
    () => [
      {
        ...Column.text('id', t('pages.posdashboard.tabs.columns.id'), {
          width: 200,
          filter: true,
          fixed: 'left',
        }),
        className: 'red',
      },
      Column.text('name', t('pages.posdashboard.tabs.columns.name'), {
        width: 200,
        filter: true,
        fixed: 'left',
      }),
      Column.text('address', t('pages.posdashboard.tabs.columns.address'), {
        width: 200,
        filter: true,
      }),
      Column.text(
        'retailerName',
        t('pages.posdashboard.tabs.columns.retailerName'),
        { width: 200, filter: true },
      ),
      Column.text(
        'sellerFullname',
        t('pages.posdashboard.tabs.columns.sellerFullname'),
        { width: 200, filter: true },
      ),
      Column.text('shiftId', t('pages.posdashboard.tabs.columns.shiftId'), {
        width: 200,
        filter: true,
      }),
      Column.date('startedAt', t('pages.posdashboard.tabs.columns.startedAt'), {
        width: 180,
        filter: true,
      }),
      Column.date(
        'posLastConnectionAt',
        t('pages.posdashboard.tabs.columns.posLastConnectionAt'),
        {
          width: 180,
          filter: true,
        },
      ),
      Column.bool(
        'posIsOnline',
        t('pages.posdashboard.tabs.columns.posIsOnline'),
        {
          width: 180,
          // filter: true,
        },
      ),
      Column.date(
        'devconLastConnectionAt',
        t('pages.posdashboard.tabs.columns.devconLastConnectionAt'),
        {
          width: 180,
          filter: true,
        },
      ),
      Column.bool(
        'devconIsOnline',
        t('pages.posdashboard.tabs.columns.devconIsOnline'),
        {
          width: 180,
          // filter: true,
        },
      ),
    ],
    [t],
  );

  return (
    <>
      <ExportEntitiesButton
        columns={columns}
        data={{
          sort,
          criterias,
        }}
        downloadFiles={downloadFetcher}
      />
      <Table
        columns={columns}
        rowKey="id"
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
        scroll={{ y: 550 }}
        style={{ marginTop: 10 }}
      />
    </>
  );
};

export default PosesStatuses;
